export default {
  NON_HIRE_ME_POSTED: 'NonHireMe Posted',
  HIRE_ME_POSTED: 'HireMe Posted',
  PROJECT_REPOSTED: 'Project Reposted',
  CONTEST_POSTED: 'Contest Posted',
  ONE_CLICK_PROJECT_POSTED: 'OneClickProject Posted',

  push(dataLayerVariable) {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer.push(dataLayerVariable);
  },

  pushEvent(value) {
    return this.push({
      event: value,
    });
  },
};
